<template>
	<slot></slot>
</template>





<script>
/*
Ref: https://github.com/fiduswriter/Simple-DataTables
*/

export default {

	props: {
		
		/**
		 * The field's `id` value. Required.  
		 * Should be unique among all elements currently rendered on the page.
		 */
		id: {
			type: String,
			required: false
		},

		/**
		 * Additional CSS class(s) to apply.  
		 * Does NOT overwrite default classes.
		 */
		cssClass: {
			type: String,
			required: false
		},
	},


	data()
	{
		return {

		};
	},






	mounted()
	{
		
	},





	computed: {

	},





	methods: {
		init()
		{

		},
	}
}
</script>





<style scoped lang="scss">
//@use "/assets/sass/styles-version-1.scss" as *;
</style>
<style lang="scss">
/** This needs to be UNSCOPED */
@use "./standard-table.scss" as *;
</style>